import React, { PureComponent } from 'react'
import { object, shape, array } from 'prop-types'
import { createComponent } from '@ycos/fela'
import { formatMoney } from 'accounting'
import { createFontStyle, getFontStyles } from '@ycos/primitives'

const ProductPriceBox = createComponent(
  'createComponent',
  ({ theme }) => ({
    display: 'block',
    margin: `${theme.spacingMultiplier * 2}px 0 0 0`,
    textAlign: 'center',
  }),
  'div'
)

const Price = createFontStyle('Label', { type: 'Label', tagName: 'p', name: '2' }, ({ theme }) => ({
  color: theme.typography.colors.PrimaryBlack,
  margin: `${theme.spacingMultiplier}px 0 0 0`,
}))

const SalePrice = createFontStyle('Label', { type: 'Label', tagName: 'p', name: '4' }, ({ theme }) => ({
  color: theme.typography.colors.SecondaryRed,
  margin: `${theme.spacingMultiplier / 2}px 0 0 0`,
}))

const Badge = createComponent(
  'Badge',
  ({ theme }) => {
    const {
      typography,
      spacingMultiplier,
    } = theme
    const { type, name, ...rest } = theme.custom.productCard?.badge 
    return {
      ...getFontStyles(typography, { type: type, name: name }),
      margin: `${spacingMultiplier / 2}px 0`,
      ...rest,
    }
  },
  'p'
)

export const filterMerchandisingBadges = (badges) => {
  return (badges || []).reduce((acc, badge) => {
    if (badge.type === 'MERCHANDISING') {
      acc.push(badge)
    }
    return acc
  }, [])
}

class ProductPrice extends PureComponent {
  render() {
    const { price, onSale, badges, currencyDisplay } = this.props
    const { rdSellingPrice, sellingPrice, rdWasPrice } = price
    const format = { symbol: currencyDisplay, precision: 0 }
    const productBadge = filterMerchandisingBadges(badges)[0]
    return (
      <ProductPriceBox data-automation="price">
        {onSale && rdWasPrice ? <Price data-automation="original">{formatMoney(rdWasPrice.amount / rdWasPrice.divisor, format )}</Price> : sellingPrice && <Price data-automation="original">{formatMoney(sellingPrice.amount / sellingPrice.divisor, format )}</Price>}
        {onSale && rdSellingPrice && <SalePrice data-automation="sale">{formatMoney(rdSellingPrice.amount / rdSellingPrice.divisor, format)}</SalePrice>}
        {productBadge && (
          <Badge key={productBadge.key} data-testid="badge" data-automation="badge">
            {productBadge.label}
          </Badge>
        )}
      </ProductPriceBox>
    )
  }
}

ProductPrice.defaultProps = {
  price: null,
  currencyDisplay: "£"
}

ProductPrice.propTypes = {
  price: shape({
    currency: object,
    rdSellingPrice: object,
    sellingPrice: object,
    badges: array,
  }).isRequired,
  currencyDisplay: object,
}

export default ProductPrice
